/* eslint-disable react-hooks/exhaustive-deps */
import { ContentLayout, CustomTable, HeaderBreadcrumbs, LoadingButton } from "../../../shared";
import React from "react";
import { Box, Button, MenuItem, Stack, Typography } from "@mui/material";
import { usePLReport } from "../hooks/usePLReport";
import { useBSReport } from "../../BSReport/hooks/useBSReport";
import MenuPopover from "../../../shared/components/MenuPropover";
import { PlAndBsListFilterSection, plAndBsReportExportTypes } from "../../List";
import { errorMessage } from "../../../utils";
import { UploadOutlined } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { PlReportFilterSection } from "../components";

export const PLReportList = () => {
  const location = useLocation();
  const isStoreAdmin = location.pathname.includes("store-admin");

  const [open, setOpen] = React.useState(false);

  const anchorRef = React.useRef(null);

  const plReport = usePLReport({
    isList: true,
  });

  const bsReport = useBSReport({
    isList: true,
  });

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const getRowProps = (row) => {
    return {
      style: {
        backgroundColor: row.original.Head ? "#E6E6E6" : "#ffffff",
      },
    };
  };

  const plColumns = React.useMemo(() => {
    if (plReport.state?.column?.length === 0) return [];
    const headerFilter = plReport.state?.column.map((val) => ({
      Header: val.header,
      accessor: (row) => {
        return val.accessor === "Variance" ? (
          <Typography
            sx={{
              fontSize: row?.["Head"] ? "16px" : "14px",
              fontWeight: row?.["Head"] ? "500" : "400",
              color:
                parseFloat(row.Variance.replace(/[^0-9.-]/g, "")) === 0
                  ? ""
                  : "rgba(233, 76, 50, 1)",
            }}
          >
            {row?.Variance}
          </Typography>
        ) : (
          row?.[val.accessor]
        );
      },
    }));

    return headerFilter;
  }, [plReport.state?.data]);

  const bsColumns = React.useMemo(() => {
    if (bsReport.state?.data.length === 0) return [];
    const headers = Object.keys(bsReport.state?.data[0]);
    const headerFilter = headers.filter((i) => i !== "Head");

    return headerFilter.map((header) => ({
      Header: header.replace(/_/g, " "),
      accessor: header,
    }));
  }, [bsReport.state?.data]);

  const tabs = React.useMemo(() => {
    const isPlExportEnabled =
      plReport.state.data.length > 0 && plReport.state.filter.isFilterApplied;
    const isBsExportEnabled =
      bsReport.state.data.length > 0 && bsReport.state.filter.isFilterApplied;
    return [
      {
        label: "Profit & Loss", // Label for the first tab
        value: "1", // Unique value for the first tab
        panel: (
          <CustomTable
            columns={plColumns}
            data={plReport.state?.data ?? []}
            searchBar={false}
            rowsSelection={false}
            defaultSearch={false}
            pagination={false}
            filterApplied={plReport.state.filter.appliedFilters}
            onFilterClear={plReport.handleClearFilter}
            onAllFilterClear={plReport.handleClearAllFilter}
            getRowProps={getRowProps}
            filterPosition={"defaultBottom"}
            hideContents={plReport.state.hideReport}
            toggleFilterSection={true}
            filterSection={
              <Stack
                width="100%"
                gap="16px"
                flexDirection={{ md: "row", xs: "column" }}
              >
                <Stack
                  flexDirection="row"
                  gap="16px"
                  flexGrow={1}
                  maxWidth={{ md: "80%", xs: "100%" }}
                  flexWrap="wrap"
                >
                  <PlReportFilterSection
                    filter={plReport.state.filter}
                    accountMonthList={true}
                    financialYearList={true}
                    storeList={!isStoreAdmin}
                    locationList={!isStoreAdmin}
                    handleChangeFilter={plReport.handleChangeFilter}
                    validator={plReport.validator}
                  />
                </Stack>
                <Stack
                  flexDirection="row"
                  gap="14px"
                  alignItems="center"
                  ml="auto"
                >
                  <LoadingButton
                    size="large"
                    variant="contained"
                    onClick={() =>
                      plReport.handleFilterApply(plReport.state.filter.values)
                    }
                    disabled={plReport.state.filter.isFilterApplied}
                    loading={plReport.state.isBusy}
                  >
                    Apply
                  </LoadingButton>
                  <Button
                    size="large"
                    variant="text"
                    ref={anchorRef}
                    onClick={handleOpen}
                    startIcon={<UploadOutlined fontSize="large" />}
                    sx={{
                      paddingBlock: "22px",
                      background: !isPlExportEnabled
                        ? "rgba(0, 0, 0, 0.12) !important"
                        : "initial",
                    }}
                    disabled={!isPlExportEnabled}
                  >
                    Export
                  </Button>
                </Stack>
              </Stack>
            }
          />
        ), // Component to render for this tab
      },
      {
        label: "Balance Sheet ", // Label for the second tab
        value: "2", // Unique value for the second tab
        panel: (
          <CustomTable
            columns={bsColumns}
            data={bsReport.state?.data}
            searchBar={false}
            rowsSelection={false}
            defaultSearch={false}
            pagination={false}
            hideContents={bsReport.state.hideReport}
            filterApplied={bsReport.state.filter.appliedFilters}
            onFilterClear={bsReport.handleClearFilter}
            onAllFilterClear={bsReport.handleClearAllFilter}
            getRowProps={getRowProps}
            filterPosition={"defaultBottom"}
            toggleFilterSection={true}
            filterSection={
              <Stack
                width="100%"
                gap="16px"
                flexDirection={{ md: "row", xs: "column" }}
              >
                <Stack
                  flexDirection="row"
                  gap="16px"
                  flexGrow={1}
                  maxWidth={{ md: "80%", xs: "100%" }}
                  flexWrap="wrap"
                >
                  <PlAndBsListFilterSection
                    filter={bsReport.state.filter}
                    accountMonthList={true}
                    financialYearList={true}
                    storeList={!isStoreAdmin}
                    handleChangeFilter={bsReport.handleChangeFilter}
                    hideMonthQuarters
                    validator={bsReport.validator}
                    locationList={!isStoreAdmin}
                  />
                </Stack>
                <Stack
                  flexDirection="row"
                  gap="14px"
                  alignItems="center"
                  ml="auto"
                >
                  <LoadingButton
                    size="large"
                    variant="contained"
                    onClick={() =>
                      bsReport.handleFilterApply(bsReport.state.filter.values)
                    }
                    disabled={bsReport.state.filter.isFilterApplied}
                    loading={bsReport.state.isBusy}
                  >
                    Apply
                  </LoadingButton>
                  <Button
                    size="large"
                    variant="text"
                    ref={anchorRef}
                    onClick={handleOpen}
                    startIcon={<UploadOutlined fontSize="large" />}
                    sx={{
                      paddingBlock: "22px",
                      background: !isBsExportEnabled
                        ? "rgba(0, 0, 0, 0.12) !important"
                        : "initial",
                    }}
                    disabled={!isBsExportEnabled}
                  >
                    Export
                  </Button>
                </Stack>
              </Stack>
            }
          />
        ), // Component to render for this tab
      },
    ];
  }, [bsReport, plReport, bsColumns, plColumns, plReport.validator]); // Dependency array is empty, memoized value won't change

  const handleExports = ({ exportType }) => {
    const currentTab = plReport?.currentTabs["plAndbs"] === "1" ? "pl" : "bs";
    if (currentTab) {
      const report = currentTab;
      const reportType =
        exportType === "pdf"
          ? plAndBsReportExportTypes[report + "Pdf"]
          : exportType === "excel"
          ? plAndBsReportExportTypes[report + "Excel"]
          : plAndBsReportExportTypes[report + "Csv"];

      currentTab === "pl"
        ? plReport.handleReportExport({ reportType })
        : bsReport.handleReportExport({ reportType });
    } else {
      errorMessage("Oops!! please reload and try again");
    }
    handleClose();
  };

  return (
    <ContentLayout
      title="PL & BS Report"
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[{ name: "Dashboard", href: "/" }, { name: "PL & BS Report" }]}
        />
      }
      tabProps={{
        label: "plAndbs",
        list: tabs,
      }}
    >
      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{
          width: 200,
          py: "8px",
          boxShadow: "0px 2px 7px rgb(0 0 0 / 25%)",
        }}
      >
        {[
          {
            label: "Export to CSV",
            type: "csv",
            icon: "/icons/icons8_export_csv 1.svg",
          },
          {
            label: "Export to Excel",
            type: "excel",
            icon: "/icons/icons8_xls 1.svg",
          },
          {
            label: "Export to Pdf",
            type: "pdf",
            icon: "/icons/icons8_pdf 1.svg",
          },
        ].map(({ icon, type, label }) => (
          <MenuItem
            key={type}
            sx={{
              typography: "body2",
              py: 1,
              px: "16px",
              height: "48px",
              gap: "16px",
            }}
            onClick={() => handleExports({ exportType: type })}
          >
            <Box component="img" src={icon} alt={label + " icon"} />
            {label}
          </MenuItem>
        ))}
      </MenuPopover>
    </ContentLayout>
  );
};
